import { setStorageAdapter } from '@travel-planner/shared/src/api/storage';
import { initApiClient } from '@travel-planner/shared/src/api/client';

// Initialize with web localStorage adapter (sync wrapped in Promises)
setStorageAdapter({
  getItem: (k) => Promise.resolve(localStorage.getItem(k)),
  setItem: (k, v) => Promise.resolve(localStorage.setItem(k, v)),
  removeItem: (k) => Promise.resolve(localStorage.removeItem(k)),
});

// Initialize API client — derive API URL dynamically from current origin
const runtimeConfig = window.__RUNTIME_CONFIG__ || {};
const API_BASE_URL = runtimeConfig.API_URL || process.env.REACT_APP_API_URL || `${window.location.origin}/api`;
initApiClient({
  baseURL: API_BASE_URL,
  onUnauthorized: () => {
    // Don't redirect on /sample/ paths - demo mode doesn't need auth
    if (window.location.pathname.startsWith('/sample/')) return;
    window.location.href = '/';
  },
  onSubscriptionInactive: (detail) => {
    window.dispatchEvent(new CustomEvent('subscription-inactive', { detail }));
  },
});

// Re-export everything — all existing imports from '../api/client' continue to work
export * from '@travel-planner/shared/src/api/client';
